import React, { useEffect, useState, useRef } from "react";
import * as Yup from "yup";
import { Formik, Form, Field, ErrorMessage } from "formik";
import { ToastContainer, toast } from "react-toastify";
import dynamic from "next/dynamic";
import {
  InstagramEmbed,
  LinkedInEmbed,
  TwitterEmbed,
} from "react-social-media-embed";
import RangeSlider from "react-range-slider-input";
import axios from "axios";
import striptags from "striptags";
import Head from "next/head";
import Link from "next/link";
import ReCAPTCHA from "react-google-recaptcha";
import { useSelector } from "react-redux";

// image
import Image from "next/image";
import proposal_img from "../../public/assets/images/proposal-img.png";
import file_upload_icon from "../../public/assets/images/file-upload-icon.png";

//css
import "../../node_modules/swiper/swiper.min.css";
import "react-range-slider-input/dist/style.css";
import "../../node_modules/swiper/swiper.min.css";
import "../../node_modules/react-toastify/dist/ReactToastify.css";
import { useRouter } from "next/router";

const Loader = dynamic(() => import("../components/common/Loader/Loader"));
const Layout = dynamic(() => import("../components/common/Layout/Layout"));

const OurClient = dynamic(() => import("../components/common/Map/Map"), {
  ssr: false, // This disables server-side rendering
});

const instagram = [
  {
    id: "1",
    url: "https://www.instagram.com/reel/CsRI_xyI_f6/?utm_source=ig_web_copy_link&igshid=ODhhZWM5NmIwOQ==",
  },
  {
    id: "2",
    url: "https://www.instagram.com/reel/Cn1gvm7KGnv/?utm_source=ig_web_copy_link&igshid=ODhhZWM5NmIwOQ==",
  },
  {
    id: "3",
    url: "https://www.instagram.com/reel/CnjmrsZqfRE/?utm_source=ig_web_copy_link&igshid=ODhhZWM5NmIwOQ==",
  },
];
const linkedin = [
  {
    id: "1",
    url: "https://www.linkedin.com/embed/feed/update/urn:li:activity:7063890354059567104",
  },
  {
    id: "2",
    url: "https://www.linkedin.com/embed/feed/update/urn:li:activity:7156302659489083392",
  },
  {
    id: "3",
    url: "https://www.linkedin.com/embed/feed/update/urn:li:activity:7063890354059567104",
  },
];

const twitter = [
  {
    id: "1",
    url: "https://twitter.com/QuixomTech/status/1628333626537689094",
  },
  {
    id: "2",
    url: "https://twitter.com/QuixomTech/status/1625816970921926656",
  },
  {
    id: "3",
    url: "https://twitter.com/QuixomTech/status/1623261245783838721",
  },
];

const contactUs = ({ apiData }) => {
  const router = useRouter();
  const sitekey = process.env.NEXT_PUBLIC_RECAPTCHA_V2_SITEKEY;
  const reCaptchaRef = useRef(null);
  const [captchaError, setCaptchaError] = useState("");
  const [captchaToken, setCaptchaToken] = useState("");

  const [minBudget, setMinBudget] = useState(500); // Initial value for min_budget
  const [maxBudget, setMaxBudget] = useState(150000);
  const [fileError, setFileError] = React.useState("");
  const [activeSocial, setActiveSocial] = useState(0);
  const [insta, setInsta] = useState([]);
  const [clients, setClients] = useState();
  const [loader, setLoader] = useState(true);
  const [activeTab, setActiveTab] = useState(0);

  const title = apiData?.page_title;
  const seo_title = apiData?.meta?.seo_title;
  const search_description = apiData?.meta?.search_description;
  const canonicalUrl = apiData?.canonical_url;
  const og_title = apiData?.og_title;
  const og_description = apiData?.og_description;
  const og_image = apiData?.og_image?.url;
  const structuredData = apiData?.struct_org_extra_json;
  const formatJson = (json) => {
    return {
      __html: `${json}`,
    };
  }

  const footerData = useSelector(
    (state) => state.headerFooterData.headerFooterDataList
  );

  // form submissions start

  const handleFileValidation = (file) => {
    const allowedExtensions = /(\.pdf|\.doc)$/i;
    const isFileValid = allowedExtensions.test(file.name);

    if (!isFileValid) {
      setFileError("Invalid file format. Please upload a PDF or DOC file.");
    } else {
      setFileError("");
    }
  };

  const handleSliderChange = (values) => {
    const increment = 500;
    const newMinBudget = Math.floor(values[0] / increment) * increment;
    const newMaxBudget = Math.ceil(values[1] / increment) * increment;

    setMinBudget(newMinBudget);
    setMaxBudget(newMaxBudget);
  };

  const renderError = (message) => <p className="help is-danger">{message}</p>;

  const validationSchema = Yup.object({
    name: Yup.string()
      .required("Please enter your name")
      .matches(
        /^[a-zA-Z\s]+$/,
        "Please enter a valid name with only alphabetical characters"
      )
      .test(
        "len",
        "Maximum 50 characters are allowed",
        (val) => val && val.toString().length < 50
      ),
    email: Yup.string()
      .email("Please enter valid email")
      .required("Please enter your email")
      .test(
        "len",
        "Maximum 50 characters are allowed",
        (val) => val && val.toString().length < 50
      ),
    phone_number: Yup.string()
      .required("Please enter your phone number")
      .matches(
        /^[0-9]+$/,
        "Please enter a valid phone number with only numeric characters"
      )
      .test(
        "len",
        "Maximum 10 characters are allowed",
        (val) => val && val.toString().length < 11
      ),
    country: Yup.string()
      .required("Please enter your country name")
      .test(
        "len",
        "Maximum 50 characters are allowed",
        (val) => val && val.toString().length < 50
      ),
    project_description: Yup.string().required(
      "Please enter your Project Description"
    ),
    upload_file: Yup.mixed(),
    select_type_of_services_you_require: Yup.mixed().required(
      "Please select service type before submitting "
    ),
  });

  const initialValues = {
    name: "",
    email: "",
    phone_number: "",
    country: "",
    project_description: "",
    select_type_of_services_you_require: "",
  };

  const validateCAPTCHA = async (token) => {
    setCaptchaToken(token);
  };

  const validateCaptchaV3 = () => {
    return new Promise((resolve, reject) => {
      reCaptchaRef.current.executeAsync().then(async (value) => {
        resolve(value);
      });
    });
  };

  const onSubmit = async (values, formikBag) => {
    try {
      const isHuman = true;

      if (isHuman) {
        const formData = new FormData();

        Object.entries(values).forEach(([key, value]) => {
          formData.append(key, value);
        });
        formData?.append("g-recaptcha-response", captchaToken);

        formData?.append("min_budget", minBudget);
        formData?.append("max_budget", maxBudget);
        axios
          .post(
            process.env.NEXT_PUBLIC_API_ENDPOINT +
            `/dynamic-form/${contactData?.form?.slug}/submissions/`,
            formData,
            {
              headers: {
                "Content-Type": "multipart/form-data",
              },
            }
          )
          .then((response) => {
            setCaptchaToken("");
            reCaptchaRef.current.reset();
            toast.success("Message Sent Successfully", {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: false,
              progress: undefined,
            });
            setTimeout(() => {
              router.push("thank-you");
            }, 1500);
          })
          .catch(({ response }) => {
            setCaptchaToken("");
            reCaptchaRef.current.reset();
            toast.error("Something Went Wrong", {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: false,
              progress: undefined,
            });
          });
        formikBag.resetForm();
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };
  // end
  const [contactData, setContactData] = useState();

  useEffect(() => {
    const data = apiData;
    data && setContactData(data);
    if (footerData) {
      setLoader(false);
    }
  }, []);

  // map section start
  useEffect(() => {
    const fetchClient = async () => {
      try {
        const response = await axios.get(
          process.env.NEXT_PUBLIC_API_ENDPOINT + "/cms/pages/contact-us/"
        );
        const data = response?.data?.detail;
        if (data) {
          const filterData = data?.filter((item) => {
            return item?.type == "client_countries";
          });
          if (filterData.length > 0) {
            setClients(filterData); // Set the entire array
          }
        }
        // if (clients) {
        //     block = clients && clients[0]?.value
        // }
      } catch (error) {
        console.log("error", error);
      }
    };
    fetchClient();
  }, []);
  // map section end

  // social media section start
  useEffect(() => {
    const fetchInsta = async () => {
      try {
        const response = await axios.get(
          process.env.NEXT_PUBLIC_API_ENDPOINT + "/social-media/"
        );
        response && setInsta(response?.data?.instagram);
      } catch (error) {
        console.log("error", error);
      }
    };

    fetchInsta();
  }, []);

  const [value, setValue] = useState([30, 60]);
  return (
    <>
      <Head>
        <title>{striptags(title)}</title>

        <meta name="title" content={seo_title} key="og-title" />

        <meta name="description" content={search_description} key="og-desc" />
        <link rel="canonical" href={canonicalUrl} />
        <meta property="og:title" content={og_title || seo_title} />
        <meta property="og:description" content={og_description || search_description} />
        <meta property="og:image" content={og_image} />
        <meta property="og:url" content={canonicalUrl} />
        <meta property="og:type" content="website" />
        <meta property="og:site_name" content="Quixom" />
        {structuredData && (
          <script
            type="application/ld+json"
            dangerouslySetInnerHTML={formatJson(structuredData)}
          />
        )}
      </Head>
      <Layout
        webLogo={
          footerData &&
          footerData?.site_configuration &&
          footerData?.site_configuration[0]?.logo?.url
        }
      >
        {loader && <Loader />}
        <ToastContainer />
        <main className="main-wrapper contact-page-middle">
          <article className="wrapper-inner">
            <section className="contact-hero-section">
              <div className="contact-hero-inner">
                <div className="container">
                  <div className="row">
                    <div className="col-lg-7">
                      {contactData?.detail?.map((val, i) => {
                        // const titleWithoutPTag = striptags(
                        //   val?.value?.title,
                        //   "<span>"
                        // );
                        const titleWithoutPTag = val?.value?.title || "";
                        if (val?.type == "banner") {
                          return (
                            <div
                              className="heading request-proposal-heading"
                              key={i}
                            >
                              <span
                                itemProp="heading"
                                dangerouslySetInnerHTML={{
                                  __html: titleWithoutPTag,
                                }}
                              ></span>
                              <div
                                className=""
                                dangerouslySetInnerHTML={{
                                  __html: val?.value?.description,
                                }}
                              ></div>
                            </div>
                          );
                        }
                      })}
                    </div>
                  </div>
                  <div className="contact-form-wrapper">
                    <Formik
                      initialValues={initialValues}
                      validationSchema={validationSchema}
                      onSubmit={onSubmit}
                    >
                      {(formik) => (
                        <Form>
                          <div className="row custom-row">
                            <div className="col-lg-7">
                              <div className="row">
                                {contactData?.form?.form_fields?.map(
                                  (val, index) => {
                                    return (
                                      <React.Fragment key={`${index}_j`}>
                                        {(val?.field_type == "singleline" ||
                                          val?.field_type == "email") && (
                                            <div className="col-md-6">
                                              <div className="input-wrapper">
                                                <div className="form-floating">
                                                  <Field
                                                    type="text"
                                                    className={`form-control ${formik.touched.clean_name &&
                                                        formik.errors.clean_name
                                                        ? "border-red-400"
                                                        : ""
                                                      }`}
                                                    placeholder={val?.label}
                                                    name={val?.clean_name}
                                                  />
                                                  <label className="form-label">
                                                    {val?.label}*
                                                  </label>
                                                </div>
                                                <ErrorMessage
                                                  name={val?.clean_name}
                                                  render={renderError}
                                                />
                                              </div>
                                            </div>
                                          )}
                                      </React.Fragment>
                                    );
                                  }
                                )}
                                {contactData?.form?.form_fields?.map(
                                  (val, index) => {
                                    return (
                                      <React.Fragment key={`${index}_j`}>
                                        {val?.field_type == "multiline" && (
                                          <div className="col-lg-12">
                                            <div className="input-wrapper">
                                              <div className="form-floating ">
                                                <textarea
                                                  name={val?.clean_name}
                                                  className={`form-control textarea-floating ${formik.touched.val
                                                      ?.clean_name &&
                                                      formik.errors.val
                                                        ?.clean_name
                                                      ? "border-red-400"
                                                      : ""
                                                    }`}
                                                  placeholder={val?.label}
                                                  onChange={formik.handleChange(
                                                    val?.clean_name
                                                  )}
                                                ></textarea>
                                                <label className="form-label">
                                                  {val?.label}*
                                                </label>
                                              </div>
                                              <ErrorMessage
                                                name={val?.clean_name}
                                                render={renderError}
                                              />
                                            </div>
                                          </div>
                                        )}
                                      </React.Fragment>
                                    );
                                  }
                                )}

                                {contactData?.form?.form_fields?.map(
                                  (val, index) => {
                                    if (val?.field_type === "multiselect") {
                                      const choicesArray = val?.choices
                                        .split(",")
                                        .map((choice) => choice.trim());

                                      return (
                                        <div key={index} className="col-lg-12">
                                          <div className="input-wrapper">
                                            <div className="form-floating">
                                              <select
                                                className="form-select form-control"
                                                id="floatingSelect"
                                                aria-label={`Select ${val.label}`}
                                                name={val.clean_name}
                                                onChange={(e) =>
                                                  formik.handleChange(
                                                    val.clean_name
                                                  )(e)
                                                }
                                              >
                                                <option value="">
                                                  Select {val.label}
                                                </option>
                                                {choicesArray.map(
                                                  (choice, choiceIndex) => (
                                                    <option
                                                      key={choiceIndex}
                                                      value={choice}
                                                    >
                                                      {choice}
                                                    </option>
                                                  )
                                                )}
                                              </select>
                                              <label htmlFor="floatingSelect">
                                                {val.label}*
                                              </label>
                                            </div>
                                          </div>
                                          <ErrorMessage
                                            name={val?.clean_name}
                                            render={renderError}
                                          />
                                        </div>
                                      );
                                    }
                                    return null;
                                  }
                                )}

                                {contactData?.form?.form_fields?.map(
                                  (val, index) => {
                                    return (
                                      <React.Fragment key={`${index}_j`}>
                                        {val?.clean_name == "min_budget" && (
                                          <div className="col-md-6">
                                            <div className="input-wrapper">
                                              <div className="custom-range-wrapper">
                                                <span className="range-title">
                                                  Select your budget*
                                                </span>
                                                <div className="custom-range-input">
                                                  <RangeSlider
                                                    values={{
                                                      min: minBudget,
                                                      max: maxBudget,
                                                    }}
                                                    defaultValue={[500, 150000]}
                                                    onInput={(values) =>
                                                      handleSliderChange(values)
                                                    }
                                                    min={500}
                                                    max={500000}
                                                    name={val?.clean_name}
                                                  />
                                                </div>
                                                <div className="range-input-value">
                                                  <span>
                                                    Min:
                                                    <span className="value">
                                                      ${minBudget}
                                                    </span>
                                                  </span>
                                                  <span>
                                                    Max:
                                                    <span className="value">
                                                      ${maxBudget}
                                                    </span>
                                                  </span>
                                                </div>
                                              </div>
                                            </div>
                                            <ErrorMessage
                                              name={val?.clean_name}
                                              render={(msg) => (
                                                <div>
                                                  {msg}
                                                  {minBudget === null &&
                                                    maxBudget === null && (
                                                      <div className="error">
                                                        Please select a budget
                                                        range
                                                      </div>
                                                    )}
                                                </div>
                                              )}
                                            />
                                          </div>
                                        )}
                                      </React.Fragment>
                                    );
                                  }
                                )}
                                {contactData?.form?.form_fields?.map(
                                  (val, index) => {
                                    return (
                                      <React.Fragment key={`${index}_j`}>
                                        {val?.field_type == "fileupload" && (
                                          <div className="col-md-6">
                                            <div className="input-wrapper">
                                              <div className="file-input">
                                                <input
                                                  type="file"
                                                  className="file-input-control"
                                                  id={val?.clean_name}
                                                  name={val?.clean_name}
                                                  onChange={(event) => {
                                                    formik.setFieldValue(
                                                      val?.clean_name,
                                                      event.currentTarget
                                                        .files[0]
                                                    );
                                                    handleFileValidation(
                                                      event.currentTarget
                                                        .files[0]
                                                    );
                                                  }}
                                                />
                                                <label
                                                  htmlFor={val?.clean_name}
                                                >
                                                  {formik.values[
                                                    val?.clean_name
                                                  ] ? (
                                                    formik.values[
                                                      val?.clean_name
                                                    ].name
                                                  ) : (
                                                    <>
                                                      <span className="input-title">
                                                        {val?.label}*
                                                      </span>
                                                    </>
                                                  )}
                                                  <span className="upload-container">
                                                    <span className="icon">
                                                      <Image
                                                        height={100}
                                                        width={100}
                                                        src={file_upload_icon}
                                                        loading="eager"
                                                        alt="Upload"
                                                      />
                                                    </span>
                                                    <span className="text">
                                                      Upload file pdf, doc,
                                                      world
                                                    </span>
                                                  </span>
                                                </label>
                                              </div>
                                            </div>
                                            <p>
                                              {formik.errors[val?.clean_name] ||
                                                fileError}
                                            </p>
                                          </div>
                                        )}
                                      </React.Fragment>
                                    );
                                  }
                                )}

                                {captchaError && (
                                  <span className="captcha-error">
                                    {captchaError}
                                  </span>
                                )}
                                <ReCAPTCHA
                                  ref={reCaptchaRef}
                                  sitekey={sitekey}
                                  onChange={validateCAPTCHA}
                                />
                                <div className="col-12">
                                  <button
                                    className="btn btn-primary"
                                    itemProp="link"
                                  >
                                    Submit
                                  </button>
                                </div>
                              </div>
                            </div>
                            <div className="col-lg-5 col-md-5 col-7">
                              <div className="contact-banner-img">
                                <Image
                                  loading="eager"
                                  height={500}
                                  width={500}
                                  src={proposal_img}
                                  alt="Request Precise Proposal"
                                />
                              </div>
                            </div>
                          </div>
                        </Form>
                      )}
                    </Formik>
                  </div>
                </div>
              </div>
            </section>
            <section className="case-studies-section">
              <div className="case-studies-inner">
                <div className="container">
                  {contactData?.detail?.map((val, index) => {
                    const titleWithoutPTag = striptags(val?.value?.heading);
                    return (
                      <React.Fragment key={`${index}_j`}>
                        {val?.type == "case_studies_block" && (
                          <>
                            <div className="row">
                              <div className="col-12 col-lg-12 col-md-12 col-sm-12">
                                <div className="case-studies-title">
                                  <div className="section-heading">
                                    <h2
                                      itemProp="heading"
                                      dangerouslySetInnerHTML={{
                                        __html: titleWithoutPTag,
                                      }}
                                    ></h2>
                                  </div>
                                  {val.value?.case_studies_list_page_chooser?.map(
                                    (val, i) => {
                                      return (
                                        <div
                                          className="section-heading-right"
                                          key={i}
                                        >
                                          <Link
                                            href={val?.value?.page?.url}
                                            itemProp="link"
                                            className="link-font-lg"
                                          >
                                            {val?.value?.heading}
                                          </Link>
                                        </div>
                                      );
                                    }
                                  )}
                                </div>
                              </div>
                            </div>
                            <div className="row">
                              <div className="col-12 col-lg-12 col-md-12 col-sm-12">
                                <div className="div-grid-row">
                                  {val?.value?.case_studies?.map((val, ind) => {
                                    return (
                                      <div
                                        className="div-grid-col"
                                        key={`${ind}_i`}
                                      >
                                        <div className="casestudies-card">
                                          {val?.value?.banner?.map((val, i) => {
                                            if (val?.type == "image") {
                                              return (
                                                <div
                                                  className="casestudies-left"
                                                  key={`${i}_k`}
                                                >
                                                  <div className="casestudies-img">
                                                    <Link
                                                      href="#"
                                                      itemProp="link"
                                                    >
                                                      <Image
                                                        height={500}
                                                        width={500}
                                                        src={val?.value?.url}
                                                        alt={val?.value?.alt_text ?? 'digital-management-system'}
                                                        loading="eager"
                                                      />
                                                    </Link>
                                                  </div>
                                                </div>
                                              );
                                            }
                                          })}

                                          <div className="casestudies-right">
                                            <div className="casestudies-description">
                                              {val?.value?.banner?.map(
                                                (val, i) => {
                                                  if (val?.type == "heading") {
                                                    return (
                                                      <h3
                                                        itemProp="heading"
                                                        key={i}
                                                      >
                                                        <Link
                                                          href="#"
                                                          dangerouslySetInnerHTML={{
                                                            __html: val?.value,
                                                          }}
                                                        ></Link>
                                                      </h3>
                                                    );
                                                  }
                                                }
                                              )}
                                              {val?.value?.overview?.map(
                                                (val, i) => {
                                                  if (val?.type == "project") {
                                                    return (
                                                      <div
                                                        className="casestudy-text"
                                                        key={`${i}_k`}
                                                      // dangerouslySetInnerHTML={{
                                                      //   __html:
                                                      //     val?.value
                                                      //       ?.description,
                                                      // }}
                                                      >
                                                        <p>
                                                          {striptags(
                                                            val?.value
                                                              ?.description
                                                          )}
                                                        </p>
                                                      </div>
                                                    );
                                                  }
                                                }
                                              )}
                                            </div>
                                            <div className="casestudies-button">
                                              <Link
                                                href={`/case-studies/${val?.value?.slug}`}
                                                itemProp="link"
                                              >
                                                <Image
                                                  height={25}
                                                  width={25}
                                                  src="../assets/images/right-arrow.svg"
                                                  alt="read-more"
                                                  loading="eager"
                                                />
                                              </Link>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    );
                                  })}
                                </div>
                              </div>
                            </div>
                          </>
                        )}
                      </React.Fragment>
                    );
                  })}
                </div>
              </div>
            </section>
            <section className="our-locations-section light-primary-background">
              <div className="our-locations-inner">
                <div className="container">
                  <div className="row">
                    <div className="col-lg-12">
                      <div className="section-heading">
                        <h2 itemProp="heading">
                          Our <span>Locations</span>
                        </h2>
                      </div>
                    </div>
                    <div className="col-lg-12">
                      <div className="our-locations-details">
                        <div className="row">
                          <div className="col-md-4 col-lg-4">
                            <div className="locations-tabs">
                              <ul className="nav" id="myTab" role="tablist">
                                {contactData?.detail?.map((val, i) => {
                                  if (val?.type == "location") {
                                    return (
                                      <React.Fragment key={`${i}_j`}>
                                        {val?.value?.map((val, index) => {
                                          return (
                                            <li
                                              className="nav-item"
                                              role="presentation"
                                              key={index}
                                            >
                                              <button
                                                className={`nav-link  ${activeTab == index
                                                    ? "active"
                                                    : ""
                                                  }`}
                                                id="ahmedabad-locations"
                                                data-bs-toggle="tab"
                                                data-bs-target="#ahmedabad-locations-info"
                                                type="button"
                                                role="tab"
                                                aria-controls="home"
                                                aria-selected="true"
                                                onClick={() => {
                                                  setActiveTab(index);
                                                }}
                                              >
                                                <span className="locations-name">
                                                  {val?.city}
                                                </span>
                                                <address className="locations-address">
                                                  {val?.address}
                                                </address>
                                              </button>
                                            </li>
                                          );
                                        })}
                                      </React.Fragment>
                                    );
                                  }
                                })}
                              </ul>
                            </div>
                          </div>
                          <div className="col-md-8 col-lg-8">
                            <div className="locations-tab-content">
                              <div className="tab-content" id="myTabContent">
                                {contactData?.detail?.map((val, i) => {
                                  if (val?.type == "location") {
                                    return (
                                      <React.Fragment key={`${i}_j`}>
                                        {val?.value?.map((val, index) => {
                                          return (
                                            <div
                                              key={index}
                                              className={`tab-pane fade ${activeTab == index
                                                  ? " show active"
                                                  : ""
                                                }`}
                                              id="ahmedabad-locations-info"
                                              role="tabpanel"
                                              aria-labelledby="ahmedabad-locations"
                                            >
                                              <div className="locations-info">
                                                <div className="locations-image">
                                                  <div className="locations-lg-image">
                                                    <Image
                                                      height={500}
                                                      width={500}
                                                      src={
                                                        val?.images[0]?.value
                                                          ?.url
                                                      }
                                                      alt={val?.images[0]?.value
                                                        ?.alt_text ?? 'ahmedabad locations'}
                                                      loading="eager"
                                                    />
                                                  </div>
                                                  <div className="locations-sm-image">
                                                    <Image
                                                      height={500}
                                                      width={500}
                                                      src={
                                                        val?.images[1]?.value
                                                          ?.url
                                                      }
                                                      alt={val?.images[1]?.value
                                                        ?.alt_text ?? 'ahmedabad locations'}
                                                      loading="eager"
                                                    />
                                                    <div className="locations-name-box">
                                                      <p>
                                                        <Image
                                                          height={100}
                                                          width={100}
                                                          src={
                                                            val?.images[2]
                                                              ?.value?.url
                                                          }
                                                          alt={val?.images[2]?.value
                                                            ?.alt_text ?? 'Location'}
                                                        />
                                                        {val?.city}
                                                      </p>
                                                    </div>
                                                  </div>
                                                </div>
                                                {val?.info != [] && (
                                                  <div className="location-business-info">
                                                    {val?.info?.map(
                                                      (val, i) => {
                                                        return (
                                                          <div
                                                            key={i}
                                                            className="location-for-business"
                                                          >
                                                            <span
                                                              className="location-label margin-bottom-10"
                                                              dangerouslySetInnerHTML={{
                                                                __html:
                                                                  val?.value
                                                                    ?.title,
                                                              }}
                                                            ></span>
                                                            <div
                                                              className=""
                                                              dangerouslySetInnerHTML={{
                                                                __html:
                                                                  val?.value
                                                                    ?.detail,
                                                              }}
                                                            ></div>
                                                          </div>
                                                        );
                                                      }
                                                    )}
                                                  </div>
                                                )}
                                              </div>
                                            </div>
                                          );
                                        })}
                                      </React.Fragment>
                                    );
                                  }
                                })}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>

            <OurClient block={clients} />
            <section className="social-media-section">
              <div className="social-media-inner">
                <div className="container">
                  <div className="row">
                    <div className="col-lg-12">
                      <div className="section-heading">
                        <h2 itemProp="heading">
                          Latest Posts on <span>Social Media</span>
                        </h2>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-lg-12">
                      <div className="social-tabs-content">
                        <div className="social-tabs">
                          <ul
                            className="nav nav-pills mb-3"
                            id="pills-tab"
                            role="tablist"
                          >
                            <li className="nav-item" role="presentation">
                              <button
                                className={`nav-link ${activeSocial == 0 ? "active" : ""
                                  }`}
                                id="pills-linkedin-tab"
                                data-bs-toggle="pill"
                                data-bs-target="#pills-linkedin"
                                type="button"
                                role="tab"
                                aria-controls="pills-linkedin"
                                aria-selected="true"
                                onClick={() => {
                                  setActiveSocial(0);
                                }}
                              >
                                LinkedIn
                              </button>
                            </li>
                            <li className="nav-item" role="presentation">
                              <button
                                className={`nav-link ${activeSocial == 1 ? "active" : ""
                                  }`}
                                id="pills-instagram-tab"
                                data-bs-toggle="pill"
                                data-bs-target="#pills-instagram"
                                type="button"
                                role="tab"
                                aria-controls="pills-instagram"
                                aria-selected="false"
                                onClick={() => {
                                  setActiveSocial(1);
                                }}
                              >
                                Instagram
                              </button>
                            </li>
                            <li className="nav-item" role="presentation">
                              <button
                                className={`nav-link ${activeSocial == 2 ? "active" : ""
                                  }`}
                                id="pills-twitter-tab"
                                data-bs-toggle="pill"
                                data-bs-target="#pills-twitter"
                                type="button"
                                role="tab"
                                aria-controls="pills-twitter"
                                aria-selected="false"
                                onClick={() => {
                                  setActiveSocial(2);
                                }}
                              >
                                Twitter
                              </button>
                            </li>
                          </ul>
                        </div>
                        <div className="social-media-content">
                          <div className="tab-content" id="pills-tabContent">
                            <div
                              className={`tab-pane fade ${activeSocial == 0 ? " show active" : ""
                                }`}
                              id="pills-linkedin"
                              role="tabpanel"
                              aria-labelledby="pills-linkedin-tab"
                            >
                              <div className="media-tab-card social-media-linkedin">
                                <div className="row">
                                  {linkedin &&
                                    linkedin?.map((val, i) => {
                                      return (
                                        <div className="col-md-4" key={i}>
                                          <LinkedInEmbed
                                            url={val.url}
                                            width={328}
                                          />
                                        </div>
                                      );
                                    })}
                                </div>
                              </div>
                            </div>
                            <div
                              className={`tab-pane fade ${activeSocial == 1 ? " show active" : ""
                                }`}
                              id="pills-instagram"
                              role="tabpanel"
                              aria-labelledby="pills-instagram-tab"
                            >
                              <div className="media-tab-card social-media-linkedin">
                                <div className="row">
                                  {instagram &&
                                    instagram?.map((val, i) => {
                                      return (
                                        <div className="col-md-4" key={i}>
                                          <InstagramEmbed
                                            url={val.url}
                                            width={328}
                                          />
                                        </div>
                                      );
                                    })}
                                </div>
                              </div>
                            </div>
                            <div
                              className={`tab-pane fade ${activeSocial == 2 ? " show active" : ""
                                }`}
                              id="pills-twitter"
                              role="tabpanel"
                              aria-labelledby="pills-twitter-tab"
                            >
                              <div className="media-tab-card social-media-linkedin">
                                <div className="row">
                                  {twitter &&
                                    twitter?.map((val, i) => {
                                      return (
                                        <div className="col-md-4" key={i}>
                                          <TwitterEmbed
                                            url={val.url}
                                            width={328}
                                          />
                                        </div>
                                      );
                                    })}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
            {/* <div style={{ display: 'flex', justifyContent: 'center' }}>
              <LinkedInEmbed
                url="https://www.linkedin.com/embed/feed/update/urn:li:share:6898694772484112384"
                postUrl="https://www.linkedin.com/posts/peterdiamandis_5-discoveries-the-james-webb-telescope-will-activity-6898694773406875648-z-D7"
                width={325}
                height={570}
              />
            </div> */}
          </article>
        </main>
      </Layout>
    </>
  );
};

export async function getServerSideProps() {
  // Fetch data from your API
  const response = await fetch(
    process.env.NEXT_PUBLIC_API_ENDPOINT + "/cms/pages/contact-us/",
    { next: { revalidate: 3600 } }
  );
  const apiData = await response.json();

  return {
    props: {
      apiData,
    },
  };
}

export default contactUs;
